module.exports = __webpack_public_path__ + "img/pxfw.df28c57f.png";